module.exports = __webpack_public_path__ + "static/media/mockupX.172c6d5a.png";